module.exports = __webpack_public_path__ + "img/avatar.e2938115.png";